export { default, Icon } from '../components/icon';
export type { IconProps } from '../types';
